<template>
    <div class="card" :class="$style.criteriaAuditCard">
        <div class="card-content" :class="$style.criteriaAuditCardTop">

            <div :class="$style.criteriaIndex" class="title padding-top">
                Criteria {{criteriaIndex}}
            </div>
            <span>{{ criteriaDetail.title }}</span>
        </div>
        <div class="card-content" :class="$style.criteriaAuditCardBottom">
            <p>All Sites</p>
            <hr :class="$style.hr"/>
            <p :class="$style.percentageTitle">Data Collected</p>
            <p>0 %</p>
            <progress class="progress is-small is-primary" :value=0 max="100">0
            </progress>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import dayjs from 'dayjs';
    import {DATE_FORMAT} from '@/utils/date.util';

    @Component({ components: {
        },
    })
    export default class CriteriaCard extends Vue {
        @Prop()
        public auditDetails: any;
        @Prop()
        public criteriaDetail: any;
        @Prop()
        public criteriaIndex!: number;

        public formatDate(s: string) {
            return dayjs(s).format(DATE_FORMAT);
        }

        get auditId() {
            return this.auditDetails.id;
        }

        public redirectToConfigureAudit() {
            this.$router.push({
                name: 'audit-sampling',
                params: {
                    auditId: this.auditId.toString(),
                },
            });
        }
    }
</script>
<style lang="scss" module>
    .criteriaAuditCard {
        background-color: #FFFFFF;
        border-radius: 4px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
        height: 350px;
    }
    .criteriaAuditCardTop {
        padding-bottom: 0;
    }
    .criteriaAuditCardBottom {
        padding-top: 0;
        position: absolute;
        width: 100%;
        bottom: 0;
        height: auto;
    }
    .criteriaIndex {
        color: #00205B;
        font-size: 24px;
        font-weight: 700;
    }

    .hr {
        margin: 0.5rem 0;
    }
    .percentageTitle {
        color: #9E9E9E;
    }
</style>
